import { render, staticRenderFns } from "./PartBaseInquiry.vue?vue&type=template&id=cff2eca2&scoped=true"
import script from "./PartBaseInquiry.vue?vue&type=script&lang=js"
export * from "./PartBaseInquiry.vue?vue&type=script&lang=js"
import style0 from "./PartBaseInquiry.vue?vue&type=style&index=0&id=cff2eca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff2eca2",
  null
  
)

export default component.exports